import {connect} from '@store/@common';

import SkillActions from 'actions/SkillActions';
import {areSkillsFetching, usedSkills} from '@store/skills';

import {SkillIdsField} from './skill-ids-field';

const mapStateToProps = {
  areSkillsFetching,
  skills: usedSkills,
};

const mapActionsToProps = {
  fetchAllSkills: SkillActions.fetchAllUsed,
};

export default connect(SkillIdsField, mapStateToProps, mapActionsToProps);
